'use strict';

export default function FilterSlidable({title, children, isOpenedInit = true, showClear = false, onClear}) {

    const dropRef = React.useRef()
    const [isOpened, setIsOpened] = React.useState(isOpenedInit);

    const handleOpen = () => {
        if (isOpened) {
            setIsOpened(false)
            $(dropRef.current).stop(true,true).slideUp()
        } else {
            setIsOpened(true)
            $(dropRef.current).stop(true,true).slideDown()
        }
    }

    const handleClearFilter = () => {
        onClear && onClear();
    }

    return <div className="el__filter">
        {showClear && <a role='button' className="el__filter-clear" data-tooltip={tMsg('Сбросить фильтр')} onClick={handleClearFilter} style={{display:'block'}}></a>}
        <div className={clsx('el__filter-title', isOpened && 'active')} onClick={handleOpen}>
            {title}
        </div>
        <div ref={dropRef} className="el__filter-content el__filter-drop" style={isOpenedInit ? {display: 'block'} : {}}>
            {children}
        </div>
    </div>
}